import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Delete5",
  "use": "icon-Delete5-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-Delete5\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 2a2 2 0 0 0-2 2v2H3v2h1.04L5 19.048A3 3 0 0 0 8 22h8a3 3 0 0 0 3-2.952L19.96 8H21V6h-5V4a2 2 0 0 0-2-2h-4Zm4 4V4h-4v2h4ZM8 8H6.047l.95 10.913L7 19a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1c0-.029.001-.058.004-.087L17.953 8H8Zm3 2v8H9v-8h2Zm4 8v-8h-2v8h2Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol